import React from "react";

import { Outlet } from "react-router-dom";
import Header from "./Header";

const Layout = ({ productTypes }) => {
  return (
    <div>
      <Header productTypes={productTypes} />
      <Outlet />
    </div>
  );
};

export default Layout;
